import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopAddSearchCoopMembers, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopMemberOtherCoop = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.JoinableCoopSelect), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.CoopMemberInfo,
            props: {
                coopId: action.coop.id,
                playerId: selectPlayerInfo(state$.value).playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return of(actionCoopAddSearchCoopMembers(res.member || []));
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopMemberOtherCoop.ts
// module id = 1813
// module chunks = 3